"use strict";
ko.extenders.confirm = function (target, options) {
    var callback = options.callback || (function (nw, ex) { return true; });
    var onlyIf = options.onlyIf || (function (nw, ex) { return nw !== ex; });
    var result = ko.computed({
        read: target,
        write: function (newValue) {
            var current = target();
            if (!onlyIf(newValue, current) || callback(newValue, current)) {
                target(newValue);
            }
            else {
                target.notifySubscribers(current);
            }
        }
    }).extend({ notify: 'always' });
    return result;
};
ko.bindingHandlers.selectedIndex = {
    init: function (element, valueAccessor) {
        var valueAccessorWriter = function () {
            var value = valueAccessor();
            if (ko.isWriteableObservable(value)) {
                value(element.selectedIndex);
            }
        };
        valueAccessorWriter();
        ko.utils.registerEventHandler(element, "change", valueAccessorWriter);
    }
};
ko.bindingHandlers.modal = {
    init: function (element, valueAccessor) {
        $(element).modal("hide");
        var value = valueAccessor();
        if (ko.isObservable(value)) {
            $(element).on('hidden.bs.modal', function () { value(false); });
        }
    },
    update: function (element, valueAccessor) {
        var value = valueAccessor();
        var valueAcc = function () { return ko.utils.unwrapObservable(value); };
        var to;
        if (valueAcc()) {
            to = $(element).data('modal-timeout');
            if (to) {
                clearTimeout(to);
            }
            to = setTimeout(function () { if (valueAcc()) {
                $(element).modal('show');
            } }, 250);
            $(element).data('modal-timeout', to);
        }
        else {
            to = $(element).data('modal-timeout');
            if (to) {
                clearTimeout(to);
            }
            to = setTimeout(function () { if (!valueAcc()) {
                $(element).modal('hide');
            } }, 500);
            $(element).data('modal-timeout', to);
        }
    }
};
ko.bindingHandlers.href = {
    init: function (element, valueAccessor) {
        var jqElement = $(element);
        var hrefElement = jqElement.attr('href');
        var modelValue = valueAccessor();
        var hrefModel = modelValue();
        if (hrefModel) {
            jqElement.attr('href', hrefModel);
        }
        else if (hrefElement && ko.isObservable(modelValue)) {
            modelValue(hrefElement);
        }
    },
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        $(element).attr('href', value ? value : '');
    }
};
ko.bindingHandlers.anyChecked = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var selector = "input[type=radio]:checked, input[type=checkbox]:checked";
        var optionName = allBindingsAccessor.get('optionName');
        var hasOptionName = !(!optionName);
        optionName = hasOptionName ? optionName.toLowerCase() : null;
        var model = valueAccessor();
        function onChanged() {
            var checkedValues = null;
            $(element).find(selector)
                .each(function (index, element) {
                var htmlElement = element;
                if (htmlElement.checked) {
                    if (!hasOptionName) {
                        checkedValues = (checkedValues || '') + (checkedValues ? ";" : "") + htmlElement.value;
                    }
                    else if (htmlElement.value.toLowerCase() === optionName) {
                        checkedValues = optionName;
                    }
                }
            });
            model(hasOptionName ? !(!checkedValues) : checkedValues);
        }
        if (ko.isObservable(model)) {
            $(element).on('change', selector, onChanged);
        }
        onChanged();
    },
    update: function (element, valueAccessor) {
    }
};
ko.bindingHandlers.filter = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var filterText = ko.utils.unwrapObservable(valueAccessor());
        if (!filterText || filterText.trim().length <= 0) {
            $(element)
                .find('tbody > tr')
                .each(function (index, row) { $(row).show(); });
        }
        else {
            var filterTexts = filterText.split(/\s+/);
            $(element)
                .find('tbody > tr')
                .each(function (index, row) {
                var isMatch = true;
                var jqRow = $(row);
                var rowText = jqRow.text();
                for (var _i = 0, filterTexts_1 = filterTexts; _i < filterTexts_1.length; _i++) {
                    var filterWord = filterTexts_1[_i];
                    if (rowText.search(new RegExp(filterWord, "i")) === -1) {
                        isMatch = false;
                        break;
                    }
                }
                if (isMatch) {
                    jqRow.show();
                }
                else {
                    jqRow.hide();
                }
            });
        }
    }
};
ko.bindingHandlers.navindex = {
    init: function (element, valueAccessor) {
        var jqElement = $(element);
        var modelValue = valueAccessor();
        if (modelValue && modelValue.no >= 0 &&
            modelValue.index && ko.isWriteableObservable(modelValue.index)) {
            jqElement.on('show.bs.tab', function (e) {
                if (e.isDefaultPrevented()) {
                    return;
                }
                modelValue.index(modelValue.no);
                if (modelValue.index() !== modelValue.no) {
                    e.preventDefault();
                }
            });
            jqElement.on('shown.bs.tab', function (e) {
                if (e.isDefaultPrevented()) {
                    return;
                }
                modelValue.index(modelValue.no);
            });
        }
        else {
            console.error('Cannot bind navactive on ' + jqElement);
        }
    },
    update: function (element, valueAccessor) {
        var jqElement = $(element);
        var modelValue = valueAccessor();
        if (jqElement.is(":hidden")) {
            return;
        }
        if (modelValue.index() === modelValue.no) {
            jqElement.tab('show');
        }
    }
};
